<template>
  <section class="pricing" id="pricing">
    <div class="container">

      <div class="section-intro">
        <div class="section-tag">版本</div>
        <h3>一机一码，一个激活码仅供一台电脑使用，激活后与机器绑定。</h3>
      </div>

      <!-- 价格卡片 -->
      <div class="pricing-grid">
        <!-- 试用版卡片：展示结构固定，功能特性从 API 读取 -->
        <div class="price-card">
          <div class="plan-header">
            <div class="plan-icon">
              <span v-html="trialMeta.icon"></span>
            </div>
            <h3>{{ trialMeta.name }}</h3>
            <p class="plan-desc">{{ trialMeta.desc }}</p>
          </div>
          <div class="plan-price">
            <span class="price-row">
              <span class="price-num">免费</span>
            </span>
          </div>
          <ul class="plan-features">
            <li v-for="f in trialData.features" :key="f.text" :class="{ 'feature-limited': f.limited }">
              <span class="feature-icon">{{ f.limited ? '⚡' : '✓' }}</span>
              {{ f.text }}
            </li>
          </ul>
          <button
            class="btn-action btn-outline-action"
            @click="scrollToDownload"
          >免费下载试用</button>
        </div>

        <!-- 付费商品卡片：完全由 API 数据驱动 -->
        <div class="price-card" v-for="product in paidProducts" :key="product.id" :class="{ popular: product.popular }">
          <div v-if="product.popular" class="popular-badge">推荐</div>
          <div class="plan-header">
            <div class="plan-icon">
              <span v-html="getPlanIcon(product.id)"></span>
            </div>
            <h3>{{ product.title }}</h3>
            <p class="plan-desc">{{ product.desc }}</p>
          </div>
          <div class="plan-price">
            <span v-if="getPlanYearlyPrice(product)" class="price-row">
              <span class="price-num">¥{{ getPlanYearlyPrice(product) }}</span>
              <span class="price-unit">/年</span>
            </span>
          </div>
          <ul class="plan-features">
            <li v-for="f in product.features" :key="f.text" :class="{ 'feature-limited': f.limited }">
              <span class="feature-icon">{{ f.limited ? '⚡' : '✓' }}</span>
              {{ f.text }}
            </li>
          </ul>

          <!-- 付费版：暂未开放购买 -->
          <button
            class="btn-action btn-disabled-action"
            disabled
          >暂未开放</button>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'SitePricing',
  data() {
    return {
      // Products — 从服务端 API 获取，失败时回退到本地硬编码（兜底数据与 ks_license 保持一致）
      products: [],
      // 试用版产品数据（从 ks_try 取 features）
      trialProduct: null,
      // 试用版固定展示的元数据（icon 是纯展示，不属于业务数据）
      trialMeta: {
        name: '试用版',
        desc: '小量图片测试体验',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
      },
      // 付费商品卡片 icon 映射（纯展示，不属于业务数据）
      planIcons: {
        'ks_image': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>',
        'ks_video': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>',
        'ks_image+ks_video': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>'
      },
      // 兜底数据：API 不可用或服务端未部署 ks_try 时使用（与 ks_license/goods 定义保持一致）
      FALLBACK_PRODUCTS: [
        {
          id: 'ks_try', title: '试用版', desc: '小量图片测试体验',
          tiers: [], popular: false,
          features: [{ text: '支持 50 张图片', limited: false }, { text: '不支持视频分析', limited: true }]
        },
        {
          id: 'ks_image', title: '图片搜索', desc: '适合只需要图片搜索的用户',
          tiers: [{ months: 12, price: 268 }], popular: false,
          features: [{ text: '图片数量不限', limited: false }, { text: '不支持视频分析', limited: true }, { text: '支持人脸搜索、智能搜图', limited: false }]
        },
        {
          id: 'ks_video', title: '视频搜索', desc: '适合只需要视频分析的用户',
          tiers: [{ months: 12, price: 268 }], popular: false,
          features: [{ text: '不支持图片分析', limited: true }, { text: '支持视频分析人脸片段', limited: false }, { text: '不限视频文件数量', limited: false }]
        },
        {
          id: 'ks_image+ks_video', title: '图片搜索 + 视频搜索', desc: '完整版',
          tiers: [{ months: 12, price: 438 }], popular: true,
          features: [{ text: '图片数量不限', limited: false }, { text: '支持视频分析人脸片段', limited: false }, { text: '不限视频文件数量', limited: false }, { text: '支持人脸搜索、智能搜图', limited: false }]
        }
      ]
    }
  },
  computed: {
    // 付费商品列表（排除试用版），按 ProductOrder 顺序
    paidProducts() {
      return this.products.filter(p => p.id !== 'ks_try')
    },
    // 试用版数据
    trialData() {
      return this.trialProduct || { features: [] }
    }
  },
  methods: {
    getPlanYearlyPrice(product) {
      if (!product || !product.tiers) return null
      const yearly = product.tiers.find(t => t.months === 12)
      return yearly ? yearly.price : null
    },
    getPlanIcon(productId) {
      return this.planIcons[productId] || ''
    },
    // ========== Fetch products from server ==========
    async fetchProducts() {
      try {
        const apiBase = window.location.origin + '/app/v1'
        const res = await fetch(apiBase + '/products')
        const envelope = await res.json()
        if (!res.ok) throw new Error('API error ' + res.status)
        const data = envelope.data !== undefined ? envelope.data : envelope
        if (Array.isArray(data) && data.length > 0) {
          this.products = data
          // 提取试用版数据
          this.trialProduct = data.find(p => p.id === 'ks_try') || null
          return // API 成功则无需兜底
        }
      } catch (e) {
        console.log('获取产品列表失败，使用本地兜底数据:', e.message || e)
      }
      // 兜底：API 不可用或未部署时，使用本地数据（与 ks_license/goods 保持一致）
      this.products = this.FALLBACK_PRODUCTS
      this.trialProduct = this.FALLBACK_PRODUCTS.find(p => p.id === 'ks_try') || null
    },

    scrollToDownload() {
      const el = document.getElementById('download')
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }
  },
  mounted() {
    this.fetchProducts()
  }
}
</script>

<style scoped>
.pricing {
  background: linear-gradient(180deg, #f8fbff 0%, #fff 100%);
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 32px;
}

.section-intro {
  text-align: center;
  padding-top: 15px;
}

.section-tag {
  display: inline-block;
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  color: #2563eb;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 20px;
  margin-bottom: 16px;
  letter-spacing: 1px;
  text-transform: uppercase;
  border: 1px solid rgba(37, 99, 235, 0.15);
}

.section-intro h2 {
  font-size: 34px;
  font-weight: 800;
  color: #1a202c;
  margin: 0 0 14px;
}

.section-intro p {
  font-size: 17px;
  color: #718096;
  margin: 0;
}

/* 价格卡片 */
.pricing-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 28px;
  margin: 30px;
}

.price-card {
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 24px;
  padding: 36px 28px;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.price-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 48px rgba(0,0,0,0.1);
}

.price-card.popular {
  border-color: #4e8cff;
  box-shadow: 0 8px 32px rgba(78, 140, 255, 0.18);
}

.popular-badge {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #4e8cff, #6ec1e4);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  padding: 5px 20px;
  border-radius: 20px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(78, 140, 255, 0.4);
}

.plan-header {
  text-align: center;
  margin-bottom: 28px;
}

.plan-icon {
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  color: var(--primary);
}

.plan-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 6px;
}

.plan-desc {
  font-size: 14px;
  color: #718096;
  margin: 0;
}

.plan-price {
  text-align: center;
  padding: 20px 0;
  border-top: 1px solid #f1f5f9;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 24px;
}

.price-row {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
}

.price-row + .price-row {
  margin-top: 6px;
}

.price-num {
  font-size: 36px;
  font-weight: 800;
  color: #1a202c;
  line-height: 1;
}

.price-unit {
  font-size: 14px;
  color: #718096;
  font-weight: 500;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 28px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}

.plan-features li {
  font-size: 14px;
  color: #4a5568;
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 1.4;
}

.feature-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.feature-limited {
  color: #718096;
}

.btn-action {
  display: block;
  width: 100%;
  padding: 13px 24px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  border: 1.5px solid #e2e8f0;
  color: #4a5568;
  transition: all 0.25s ease;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  background: #fff;
}

.btn-action:hover {
  border-color: #4e8cff;
  color: #4e8cff;
  background: rgba(78, 140, 255, 0.04);
}

.btn-primary-action {
  background: linear-gradient(135deg, #4e8cff, #6ec1e4) !important;
  color: #fff !important;
  border-color: transparent !important;
  box-shadow: 0 4px 16px rgba(78, 140, 255, 0.35);
}

.btn-primary-action:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(78, 140, 255, 0.45) !important;
  color: #fff !important;
}

.btn-outline-action {
  background: #fff !important;
}

.btn-outline-action:hover {
  background: rgba(78, 140, 255, 0.04) !important;
}

.btn-disabled-action {
  display: block;
  width: 100%;
  padding: 13px 24px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  border: 1.5px solid #e2e8f0;
  color: #a0aec0;
  background: #f7fafc;
  text-align: center;
  cursor: not-allowed;
}

@media (max-width: 800px) {
  .pricing-grid { grid-template-columns: repeat(2, 1fr); max-width: 600px; margin: 0 auto 60px; }
  .section-intro h2 { font-size: 26px; }
}

@media (max-width: 540px) {
  .container { padding: 0 16px; }
}
</style>
